const fireProtectionGroupMap = {
	0: 'Brandsäkerhet',
	1: 'Brandlarm',
	2: 'Inbrottslarm',
	3: 'Utrymning',
	4: 'Första hjälpen',
	5: 'Övrigt'
};

const typeMap = [
	'Annat',
	'Avstängning el',
	'Branddörr',
	'Branddörr magnet',
	'Branddörr självstängande',
	'Brandfilt',
	'Pulversläckare',
	'Skumsläckare',
	'Kolsyresläckare',
	'Vattenbrandsläckare',
	'Fettbrandsläckare',
	'AVD-Litiumbrandsläckare',
	'Brandvarnare',
	'Centralapparat',
	'Centrumrulle',
	'Första hjälpen',
	'Handlampa',
	'Hjärtstartare',
	'Larmknapp brand',
	'Larmknapp utrymning',
	'Nödbelysning',
	'Nödtelefon',
	'Röklucka',
	'Sprinkler manuell',
	'Sprinklercentral',
	'Utrymningsväg',
	'Utrymningsplan',
	'Hänsvisningsarmatur',
	'Brandpost',
	'Laddning av batteri pågar',
	'Farlig elektrisk spänning',
	'Ögondusch',
	'Lastplats',
	'Hänsvisningsarmatur efterlysande',
	'Undercentral',
	'Brandfarlig vara',
	'Brandcellsgräns',
	'Släcksystem kök',
	'Gassläcksystem',
	'Punktskydd',
	'Siren',
	'Centralapparat inbrott',
	'Manöverpanel',
	'Rörelsedetektor',
	'Magnetkontakt',
	'Rökdetektor',
	'Larmknapp',
	'Vibrationsdetektor',
	'Limmad glaskrossdetektor',
	'Rörelsedetektor, foto',
	'Aukustisk glaskrossdetektor',
	'Sektionskort, rio',
	'Driftlarm',
	'Läsare/fbk/passage',
	'Livekamera',
	'Router',
	'Utrymningstrappa',
	'Utrymningsstege',
	'Farlig eletrisk spänning',
	'Truckladdningsplats',
	'Brandport',
	'Adressenhet',
	'Aukustiskt larmdon, siren',
	'brandförsvarstablå',
	'Centralutrustning',
	'Dörrhallarmagnet',
	'Indikeringstablå, dold detektor',
	'Kombidetektor',
	'Linjerökdetektor reflektor',
	'Linjerökdetektor sändare',
	'Nätsäkring',
	'Optiskt larmdon',
	'Slutmotstånd',
	'Strömförsörjning',
	'Värmedetektor, kapslad',
	'Värmedetektor',
	'Gasbehållare',
	'Brandgasfläkt'
];

export default {
	methods: {
		getType(type) {
			switch (type.toLowerCase()) {
			case 'pulversläckare':
			case 'skumsläckare':
			case 'kolsyresläckare':
			case 'vattenbrandsläckare':
			case 'fettbrandsläckare':
			case 'avd-litiumbrandsläckare':
				return 'fire-extinguisher';
			case 'centrumrulle':
				return 'fire-roll';
			case 'första hjälpen':
				return 'first-aid';
			case 'larmknapp brand':
				return 'fire-alarm';
			case 'larmknapp utrymning':
				return 'evacuate';
			case 'nödtelefon':
				return 'emergency-phone';
			case 'utrymningsväg':
				return 'emergency-exit';
			case 'hänsvisningsarmatur':
			case 'vägledande markering':
			case 'hänsvisningsarmatur efterlysande':
			case 'vägledande markering efterlysande':
				return 'guide-sign';
			case 'branddörr':
				return 'fire-door1';
			case 'branddörr magnet':
				return 'fire-door2';
			case 'branddörr självstängande':
				return 'fire-door3';
			case 'centralapparat':
				return 'central';
			case 'brandfilt':
				return 'fire-blanket';
			case 'nödbelysning':
				return 'emergency-light';
			case 'avstängning el':
				return 'power-shutoff';
			case 'röklucka':
				return 'smoke-hatch';
			case 'handlampa':
				return 'flashlight';
			case 'hjärtstartare':
				return 'heart-starter';
			case 'utrymningsplan':
				return 'escape-plan';
			case 'sprinklercentral':
				return 'sprinkler-central';
			case 'sprinkler manuell':
				return 'sprinkler-manual';
			case 'brandvarnare':
				return 'smoke-warner';
			case 'ögondusch':
				return 'eye-shower';
			case 'brandcellsgräns':
				return 'brandcellsgrans';
			case 'släcksystem kök':
				return 'slacksystem_kok';
			case 'gassläcksystem':
				return 'gasslacksystem';
			case 'punktskydd':
				return 'punktskydd';
			case 'siren':
				return 'siren';
			case 'centralapparat inbrott':
				return 'centralapparat';
			case 'manöverpanel':
				return 'manoverpanel';
			case 'rörelsedetektor':
				return 'rorelsedetektor';
			case 'magnetkontakt':
				return 'magnetkontakt';
			case 'rökdetektor':
				return 'rokdetektor';
			case 'larmknapp':
				return 'larmknapp_burglar';
			case 'vibrationsdetektor':
				return 'vibrationsdetektor';
			case 'limmad glaskrossdetektor':
				return 'limmad_glaskrossdetektor';
			case 'rörelsedetektor, foto':
				return 'rorelsedetektor_foto';
			case 'aukustisk glaskrossdetektor':
				return 'aukustisk_glaskrossdetektor';
			case 'sektionskort, rio':
				return 'sektionskort_rio';
			case 'driftlarm':
				return 'driftlarm';
			case 'läsare/fbk/passage':
				return 'lasare_fbk_passage';
			case 'livekamera':
				return 'livekamera';
			case 'router':
				return 'router';
			case 'utrymningstrappa':
				return 'utrymningstrappa';
			case 'utrymningsstege':
				return 'utrymningsstege';
			case 'farlig eletrisk spänning':
				return 'farlig_eletrisk_spanning';
			case 'truckladdningsplats':
				return 'truckladdningsplats';
			case 'brandport':
				return 'brandport';
			case 'adressenhet':
				return 'adressenhet';
			case 'aukustiskt larmdon, siren':
				return 'akustiskt_larmdon_siren';
			case 'brandförsvarstablå':
				return 'brandforsvarstabla';
			case 'centralutrustning':
				return 'centralutrustning';
			case 'dörrhallarmagnet':
				return 'dorrhallarmagnet';
			case 'indikeringstablå, dold detektor':
				return 'indikeringstabla_dold_detektor';
			case 'kombidetektor':
				return 'kombidetektor';
			case 'linjerökdetektor reflektor':
				return 'linjerokdetektor_reflektor';
			case 'linjerökdetektor sändare':
				return 'linjerokdetektor_sandare';
			case 'nätsäkring':
				return 'natsakring';
			case 'optiskt larmdon':
				return 'optiskt_larmdon';
			case 'slutmotstånd':
				return 'slutmotstand';
			case 'strömförsörjning':
				return 'stromforsorjning';
			case 'värmedetektor, kapslad':
				return 'varmedetektor_kapslad';
			case 'värmedetektor':
				return 'varmedetektor';
			case 'gasbehållare':
				return 'gasbehallare';
			case 'brandgasfläkt':
				return 'brandgasflakt';
			default:
				return 'misc';
			}
		},
		getFireProtectionGroup(getFireProtectionGroup) {
			return fireProtectionGroupMap[getFireProtectionGroup];
		},
		getFireProtectionGroupMap() {
			return fireProtectionGroupMap;
		},
		getFireProtectionTypes() {
			return typeMap.sort();
		}
	}
};
